import React from 'react';
import { useParams, Link, Navigate } from 'react-router-dom';
import SeoHead from '../components/SeoHead';
import CtaSection from '../components/CtaSection';
import { getOptimizedImageUrl } from '../lib/cms';

export const servicesData = {
  'content-redigering': {
    slug: 'content-redigering',
    alias: 'redigering',
    icon: 'fa-light fa-video',
    tag: 'Content & Redigering',
    title: 'Content Opsætning & Redigering',
    heroTitle: 'Professionel redigering og opsætning af jeres indhold',
    subtitle: 'I filmer og sender råmaterialet til os online – vi klipper, tekster, optimerer hooks og gør jeres content knivskarpt til Instagram Reels, TikTok og Facebook.',
    image: 'https://assets.auxodev.dk/assets/d61c94bc-c5ec-439d-a220-afcc00eef7a0/production-editing-studio.png',
    metaTitle: 'Content Opsætning & Redigering | Myserviceforyou',
    metaDesc: 'Få redigeret og opsat jeres videoer og content professionelt. I optager og sender materialet online – vi klipper og optimerer. 0 binding.',
    overview:
      'I behøver ikke have et stort kamerahold på besøg for at have en levende og professionel profil. Vores online service er skræddersyet til travle forretninger: I fanger hverdagsøjeblikkene, jeres produkter eller services med smartphone og sender filerne direkte online til os. Vi klipper, farvejusterer, lægger dynamiske undertekster og trending lyd på, så videoerne fanger målgruppens opmærksomhed fra første sekund.',
    checklist: [
      'Professionel klipning og tilpasning i vertikalt 9:16 format',
      'Dynamiske undertekster og fængende hooks for øget watch time',
      'Valg af trending lyde og royalty-free underlægningsmusik',
      'Farveoptimering, skarphed og indsættelse af logo/branding',
      'Færdige videoer leveret online klar til udgivelse',
    ],
    benefits: [
      {
        icon: 'fa-light fa-cloud-arrow-up',
        title: 'Nem fildeling & levering',
        desc: 'Send nemt jeres råklip via fildeling – vi returnerer færdigt indhold.',
      },
      {
        icon: 'fa-light fa-handshake-slash',
        title: '0 binding',
        desc: 'Fuld fleksibilitet tilpasset jeres tempo – ingen uopsigelige kontrakter.',
      },
      {
        icon: 'fa-light fa-bolt',
        title: 'Hurtig turn-around',
        desc: 'Få jeres videoer hurtigt retur i professionel kvalitet klar til SoMe.',
      },
      {
        icon: 'fa-light fa-sparkles',
        title: '2 mdr + 1 gratis',
        desc: 'Benyt vores introduktionstilbud: betal for 2 mdr. og få 1 mdr. gratis.',
      },
    ],
  },

  'online-vejledning': {
    slug: 'online-vejledning',
    alias: 'vejledning',
    icon: 'fa-light fa-camera-viewfinder',
    tag: 'Online Vejledning',
    title: 'Online Vejledning til Video & Billeder',
    heroTitle: 'Vejledning i at optage fængende videoer og billeder',
    subtitle: 'Sparring og vejledning til, hvordan I selv tager gode billeder og optager videoer – med fleksibilitet til at komme ud ved nærmere aftale.',
    image: 'https://assets.auxodev.dk/assets/d61c94bc-c5ec-439d-a220-afcc00eef7a0/service-some-guidance.png',
    metaTitle: 'Online Vejledning til Video & Foto | Myserviceforyou',
    metaDesc: 'Få personlig online vejledning til smartphone-optagelser, vinkler, lys og formater. Lær at skabe autentisk indhold i din egen forretning.',
    overview:
      'Det mest effektive indhold på sociale medier i dag er ofte det ægte, nærværende materiale skudt direkte i hverdagen. Men hvordan sikrer man godt lys, ren lyd og spændende vinkler? Gennem personlig online sparring og klare guidelines vejleder vi jer i, hvad I skal filme, hvordan I holder telefonen, og hvilke situationer der skaber mest engagement hos jeres følgere.',
    checklist: [
      'Gennemgang af bedste kameraindstillinger på jeres smartphone',
      'Vejledning i naturligt lys, vinkler og rolige kamerabevægelser',
      'Idéliste over scener og vinkler (uanset om I driver hotel, Airbnb, restaurant eller butik)',
      'Gode råd til lyd og hvordan I optager uden unødig støj',
      'Løbende online feedback på jeres råoptagelser',
    ],
    benefits: [
      {
        icon: 'fa-light fa-comments-question',
        title: 'Fokuseret sparring',
        desc: 'Konkret feedback og instruktioner tilpasset jeres branche og ønsker.',
      },
      {
        icon: 'fa-light fa-mobile-screen',
        title: 'Brug din smartphone',
        desc: 'Intet behov for dyrt kameraudstyr – telefonen i lommen er rigeligt.',
      },
      {
        icon: 'fa-light fa-location-dot',
        title: 'Fleksibel on-site',
        desc: 'Ved nærmere aftale er vi fleksible til også at komme ud og hjælpe hos jer.',
      },
      {
        icon: 'fa-light fa-comments',
        title: 'Løbende sparring',
        desc: 'Spørg om råd, når I står med en idé eller er i tvivl om en vinkel.',
      },
    ],
  },

  'meta-postkalender': {
    slug: 'meta-postkalender',
    alias: 'postkalender',
    icon: 'fa-light fa-calendar-days',
    tag: 'Planlægning & Meta',
    title: 'Meta SoMe Postkalender & Planlægning',
    heroTitle: 'Oprettelse og vedligeholdelse af Meta postkalender',
    subtitle: 'Få ro i maven med en struktureret content- og postkalender i Meta (Instagram & Facebook). Vi sørger for planlægning, så I udkommer fast.',
    image: 'https://assets.auxodev.dk/assets/d61c94bc-c5ec-439d-a220-afcc00eef7a0/service-meta-calendar.png',
    metaTitle: 'Meta SoMe Postkalender & Planlægning | Myserviceforyou',
    metaDesc: 'Få oprettet og vedligeholdt jeres Meta SoMe postkalender. Fast planlægning, rolige rammer og kontinuerlig synlighed på Instagram og Facebook.',
    overview:
      'En af de største udfordringer ved sociale medier er kontinuitet. Når hverdagen rammer, bliver opslag hurtigt udskudt. Med vores Meta postkalender-service overtager vi planlægningen og vedligeholdelsen for jer. Vi opbygger en overskuelig kalender, forbereder udgivelsestidspunkter, udformer fængende tekster (captions) og sørger for, at jeres profil forbliver aktiv og relevant hver uge.',
    checklist: [
      'Opsætning og løbende opdatering af Meta content- og postkalender',
      'Planlægning af opslag, Reels og Stories på optimale tidspunkter (fx booking-peaks torsdag-søndag for ophold)',
      'Udarbejdelse af fængende opslagstekster (captions) og relevante tags',
      'Månedligt visuelt overblik over kommende opslag til forhåndsgodkendelse',
      'Struktur og rød tråd på tværs af Instagram og Facebook',
    ],
    benefits: [
      {
        icon: 'fa-light fa-clock-rotate-left',
        title: 'Spar masser af tid',
        desc: 'Slip for at stresse over "hvad skal vi lægge op i dag?".',
      },
      {
        icon: 'fa-light fa-chart-line-up',
        title: 'Stabil synlighed',
        desc: 'Algoritmen belønner jævnlige udgivelser – vi sikrer rytmen.',
      },
      {
        icon: 'fa-light fa-meta',
        title: 'Meta Business Suite',
        desc: 'Vi bruger de officielle Meta-værktøjer for maksimal sikkerhed.',
      },
      {
        icon: 'fa-light fa-check-double',
        title: 'Fuld kontrol',
        desc: 'I godkender altid kalenderen inden udgivelserne sættes i gang.',
      },
    ],
  },

  'profil-opsaetning': {
    slug: 'profil-opsaetning',
    alias: 'profil',
    icon: 'fa-light fa-sliders',
    tag: 'Profil & Identitet',
    title: 'Opsætning af Sociale Medier',
    heroTitle: 'Professionel opsætning og optimering af jeres SoMe profiler',
    subtitle: 'Giv jeres virksomhed et professionelt og indbydende udtryk på tværs af jeres platforme med skarp profiltekst, visuel identitet og korrekt opsætning.',
    image: 'https://assets.auxodev.dk/assets/d61c94bc-c5ec-439d-a220-afcc00eef7a0/agency-founders-meeting.png',
    metaTitle: 'Opsætning af Sociale Medier | Myserviceforyou',
    metaDesc: 'Få sat dine sociale medier professionelt op. Optimering af bio, layout, højdepunkter, links og Meta Business. Kontakt os for uforpligtende dialog.',
    overview:
      'Profilen er jeres digitale visitkort. Når potentielle kunder lander på jeres Instagram eller Facebook, afgør de første få sekunder, om de trykker "følg" eller handler. Vi kan stå for at sætte jeres sociale medier op fra bunden eller give de eksisterende profiler et gennemgribende løft med knivskarp bio, link-struktur, visuelle cover-ikoner og korrekt kobling til Meta.',
    checklist: [
      'Gennemgang og optimering af Instagram- og Facebook-profiler',
      'Udarbejdelse af præcis og konverterende bio-tekst med stærkt værditilbud',
      'Design af visuelle story highlight-covers og fastgjorte opslag (pins)',
      'Opsætning af Linktree / link-in-bio til webshop, booking eller kontakt',
      'Opsætning af virksomhedskonto og integration i Meta Business Manager',
    ],
    benefits: [
      {
        icon: 'fa-light fa-sparkles',
        title: 'Professionelt førstehåndsindtryk',
        desc: 'Fremstå troværdig, æstetisk og indbydende fra dag ét.',
      },
      {
        icon: 'fa-light fa-arrow-up-right-from-square',
        title: 'Konvertering til kunder',
        desc: 'Gør det nemt for besøgende at finde jeres kontaktinfo eller produkter.',
      },
      {
        icon: 'fa-light fa-gear',
        title: 'Korrekt teknisk setup',
        desc: 'Vi forbinder konti og sikrer, at alle indstillinger står rigtigt.',
      },
      {
        icon: 'fa-light fa-envelope-open-text',
        title: 'Uforpligtende dialog',
        desc: 'Ingen faste pakker – vi tilpasser opsætningen til jeres behov.',
      },
    ],
  },
};

// Aliases for backwards compatibility from older URLs
const aliases = {
  'erhvervsservice': 'content-redigering',
  'erhverv': 'content-redigering',
  'privatservice': 'online-vejledning',
  'privat': 'online-vejledning',
  'ejendomsservice': 'meta-postkalender',
  'ejendom': 'meta-postkalender',
  'hovedrengoering': 'profil-opsaetning',
};

export default function ServiceDetailPage() {
  const { slug } = useParams();

  // Handle redirects for aliases
  const targetSlug = aliases[slug] || slug;
  if (aliases[slug]) {
    return <Navigate to={`/ydelser/${targetSlug}`} replace />;
  }

  const service = servicesData[targetSlug];

  if (!service) {
    return <Navigate to="/ydelser" replace />;
  }

  // Related other services
  const otherServices = Object.values(servicesData).filter((s) => s.slug !== service.slug);

  return (
    <>
      <SeoHead
        title={service.metaTitle}
        description={service.metaDesc}
      />

      {/* Hero Section */}
      <section className="pt-40 pb-20 md:pt-48 lg:pt-52 md:pb-24 bg-[#FAF8F5] border-b border-[#E8E2D9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="max-w-3xl space-y-6">
            <div className="flex items-center gap-3">
              <Link
                to="/ydelser"
                className="text-xs font-semibold uppercase tracking-widest text-[#8C867D] hover:text-[#161514] transition-colors"
              >
                Ydelser
              </Link>
              <span className="text-[#8C867D]">/</span>
              <span className="text-xs font-semibold uppercase tracking-widest text-[#A8885B]">
                {service.tag}
              </span>
            </div>

            <h1 className="text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-[#161514] leading-[1.1]">
              {service.heroTitle}
            </h1>

            <p className="text-lg sm:text-xl text-[#5C5852] leading-relaxed">
              {service.subtitle}
            </p>

            <div className="pt-4 flex flex-wrap items-center gap-4">
              <Link
                to="/kontakt"
                className="inline-flex items-center justify-center gap-2 px-8 py-4 rounded-full bg-[#161514] text-[#FAF8F5] font-semibold text-base hover:bg-[#2A2926] active:scale-98 transition-all shadow-md"
              >
                <span>Kontakt for uforpligtende aftale</span>
                <i className="fa-regular fa-arrow-right text-sm" aria-hidden="true" />
              </Link>
              <Link
                to="/saadan-arbejder-vi"
                className="inline-flex items-center justify-center gap-2 px-6 py-4 rounded-full border border-[#D5CFC5] bg-white text-[#161514] font-medium text-sm hover:bg-[#F2ECE4] transition-colors"
              >
                <span>Se hvordan vi arbejder</span>
              </Link>
            </div>
          </div>
        </div>
      </section>

      {/* Offer Banner: 2 mdr + 1 mdr gratis */}
      <section className="py-4 bg-[#161514] text-white">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 flex flex-col sm:flex-row items-center justify-between gap-3 text-center sm:text-left">
          <div className="flex items-center gap-3 text-sm">
            <span className="inline-flex items-center justify-center px-2.5 py-0.5 rounded-full bg-[#C5A880] text-[#161514] text-xs font-bold uppercase tracking-wider">
              Kampagne
            </span>
            <span className="font-medium text-[#FAF8F5]">
              Betal for 2 måneder og få 1 måned gratis – 0 binding & fleksibel aftale
            </span>
          </div>
          <Link
            to="/kontakt"
            className="text-xs font-semibold text-[#C5A880] hover:text-white underline underline-offset-4 transition-colors"
          >
            Hør mere om tilbuddet &rarr;
          </Link>
        </div>
      </section>

      {/* Main Content & Checklist */}
      <section className="py-20 md:py-28 bg-white border-b border-[#E8E2D9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 lg:gap-16 items-start">
            {/* Left Col: Overview & Checklist */}
            <div className="lg:col-span-7 space-y-12">
              <div className="space-y-6">
                <span className="text-xs uppercase tracking-widest text-[#8C867D] font-bold">
                  Om denne online service
                </span>
                <h2 className="text-2xl sm:text-3xl font-bold tracking-tight text-[#161514]">
                  Hvad indebærer servicen?
                </h2>
                <p className="text-base sm:text-lg text-[#5C5852] leading-relaxed">
                  {service.overview}
                </p>
              </div>

              {/* Checklist Box */}
              <div className="bg-[#FAF8F5] border border-[#E5DFD6] rounded-3xl p-8 sm:p-10 space-y-6 shadow-xs">
                <h3 className="text-xl font-bold text-[#161514]">
                  Hvad vi kan hjælpe med:
                </h3>
                <ul className="space-y-4">
                  {service.checklist.map((item, index) => (
                    <li key={index} className="flex items-start gap-3.5 text-[#423E38] text-base">
                      <span className="shrink-0 w-6 h-6 rounded-full bg-[#161514] text-[#FAF8F5] flex items-center justify-center text-xs mt-0.5">
                        <i className="fa-solid fa-check" aria-hidden="true" />
                      </span>
                      <span>{item}</span>
                    </li>
                  ))}
                </ul>
              </div>

              {/* No fixed packages notice */}
              <div className="p-6 rounded-2xl bg-[#F5F1EB] border border-[#E8E2D9] space-y-2">
                <h4 className="font-bold text-[#161514] text-sm flex items-center gap-2">
                  <i className="fa-light fa-sliders text-[#A8885B]" aria-hidden="true" />
                  Ingen faste prispakker – skræddersyet til jeres behov
                </h4>
                <p className="text-xs sm:text-sm text-[#615C54] leading-relaxed">
                  Hver forretning og virksomhed har brug for noget forskelligt i forskelligt omfang. Derfor arbejder vi ikke med rigide prispakker, men sammensætter en fleksibel aftale med 0 binding, der passer nøjagtigt til jeres ønsker og budget.
                </p>
              </div>
            </div>

            {/* Right Col: Image & Contact Card */}
            <div className="lg:col-span-5 space-y-8">
              <div className="rounded-3xl overflow-hidden shadow-lg aspect-4/3 bg-[#161514] border border-[#E5DFD6]">
                <img
                  src={getOptimizedImageUrl(service.image, { width: 800, quality: 85, format: 'auto' })}
                  alt={service.title}
                  className="w-full h-full object-cover"
                />
              </div>

              {/* Contact Card */}
              <div className="bg-[#161514] text-[#FAF8F5] rounded-3xl p-8 space-y-6 shadow-xl">
                <div className="space-y-2">
                  <span className="text-xs uppercase tracking-widest text-[#C5A880] font-bold">
                    Fleksibel online service
                  </span>
                  <h3 className="text-2xl font-bold text-white tracking-tight">
                    Klar til en uforpligtende snak?
                  </h3>
                  <p className="text-sm text-[#C4BEB5] leading-relaxed">
                    Kontakt os for en kort uforpligtende samtale om jeres forretning, så finder vi den helt rigtige løsning for jer.
                  </p>
                </div>

                <div className="pt-2">
                  <Link
                    to="/kontakt"
                    className="w-full inline-flex items-center justify-center gap-2 py-4 rounded-full bg-[#FAF8F5] text-[#161514] font-semibold text-sm hover:bg-[#EFEAE2] transition-colors"
                  >
                    <span>Kontakt os nu</span>
                    <i className="fa-regular fa-arrow-right text-xs" aria-hidden="true" />
                  </Link>
                </div>

                <div className="pt-4 border-t border-white/10 text-xs text-[#9E978E] space-y-2">
                  <div className="flex items-center gap-2">
                    <i className="fa-light fa-check text-[#C5A880]" aria-hidden="true" />
                    <span>0 binding – fleksible vilkår</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="fa-light fa-check text-[#C5A880]" aria-hidden="true" />
                    <span>Sparring, redigering & synlighed</span>
                  </div>
                  <div className="flex items-center gap-2">
                    <i className="fa-light fa-check text-[#C5A880]" aria-hidden="true" />
                    <span>Kampagne: Betal 2 mdr, få 1 mdr gratis</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>

      {/* Benefits Grid */}
      <section className="py-20 md:py-28 bg-[#F5F1EB] border-b border-[#E8E2D9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="text-center max-w-3xl mx-auto mb-16 space-y-4">
            <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-[#161514]">
              Fordele ved denne service
            </h2>
            <p className="text-base text-[#5C5852]">
              Gennemskueligt, fleksibelt og skabt til at gøre hverdagen lettere for jer.
            </p>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
            {service.benefits.map((b, i) => (
              <div
                key={i}
                className="bg-white border border-[#E5DFD6] rounded-3xl p-8 space-y-4 shadow-xs"
              >
                <div className="text-[#C5A880] text-3xl">
                  <i className={b.icon} aria-hidden="true" />
                </div>
                <h3 className="text-lg font-bold text-[#161514] tracking-tight">
                  {b.title}
                </h3>
                <p className="text-xs sm:text-sm text-[#5C5852] leading-relaxed">
                  {b.desc}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Other Services */}
      <section className="py-20 md:py-28 bg-white border-b border-[#E8E2D9]">
        <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
          <div className="flex flex-col md:flex-row md:items-end justify-between mb-16 gap-6">
            <div className="space-y-4 max-w-xl">
              <h2 className="text-2xl sm:text-3xl md:text-4xl font-bold tracking-tight text-[#161514]">
                Udforsk vores øvrige ydelser
              </h2>
              <p className="text-base text-[#5C5852]">
                Vi hjælper også med rådgivning, kalenderstyring og profilopsætning.
              </p>
            </div>
            <Link
              to="/ydelser"
              className="inline-flex items-center gap-2 text-sm font-semibold text-[#161514] hover:text-[#A8885B] transition-colors"
            >
              <span>Se alle ydelser</span>
              <i className="fa-regular fa-arrow-right text-xs" aria-hidden="true" />
            </Link>
          </div>

          <div className="grid grid-cols-1 md:grid-cols-3 gap-8">
            {otherServices.slice(0, 3).map((item) => (
              <Link
                key={item.slug}
                to={`/ydelser/${item.slug}`}
                className="group bg-[#FAF8F5] border border-[#E5DFD6] rounded-3xl overflow-hidden flex flex-col hover:border-[#C5A880] transition-all hover:shadow-lg"
              >
                <div className="aspect-16/10 overflow-hidden bg-[#161514]">
                  <img
                    src={getOptimizedImageUrl(item.image, { width: 600, quality: 80, format: 'auto' })}
                    alt={item.title}
                    className="w-full h-full object-cover group-hover:scale-103 transition-transform duration-500"
                  />
                </div>
                <div className="p-6 sm:p-8 flex-1 flex flex-col justify-between space-y-4">
                  <div className="space-y-2">
                    <span className="text-xs uppercase tracking-widest text-[#A8885B] font-bold">
                      {item.tag}
                    </span>
                    <h3 className="text-xl font-bold text-[#161514] group-hover:text-[#A8885B] transition-colors">
                      {item.title}
                    </h3>
                    <p className="text-xs sm:text-sm text-[#5C5852] line-clamp-2">
                      {item.subtitle}
                    </p>
                  </div>
                  <div className="pt-2 flex items-center gap-2 text-xs font-semibold text-[#161514]">
                    <span>Læs mere</span>
                    <i className="fa-regular fa-arrow-right text-[10px] group-hover:translate-x-1 transition-transform" aria-hidden="true" />
                  </div>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <CtaSection
        title="Klar til at styrke din virksomheds synlighed?"
        subtitle="Alle aftaler laves individuelt gennem kontakt. Ingen faste pakker eller binding – kun fleksibel service tilpasset dit behov."
        primaryButtonText="Kontakt os for en snak"
        primaryButtonLink="/kontakt"
        backgroundImage={service.image}
      />
    </>
  );
}
